import Footer from "../../footer"
import NavBar from "../../nav"

const SOPS = () => {
  return <div className='sops'>
    <NavBar />
    <div>
    <section className="clean-block pfa-content clearfix">
			<div className="divider sections">
				<h1>Standard Operating Procedures</h1>
				<div className="headline-divider sections"></div>
				<h2>The core of our manual system.</h2>
				<h3>Our Collective Resource Management for SMS.</h3>
			</div>
		</section>
    <section className="clean-block clearfix">
			<div className="container content-container about-container">	
				<div className="prose">For over twenty-years, Fly Compliant, LLC has developed manuals for some of the largest part 91, 125 and 135 operations. To develop a compliant manual system there are various guidance materials referenced beyond the regulatory requirement. Our added value is our Collective Resource Management for SMS.</div>
				<div className="prose not-first">We have developed a safety board among our users to continuously review our LevelFlight SMS data across users and makes recommendations to determine best practices.</div>
				<div className="prose not-first">SOPs are the core of our manual system enhancing safety and optimizing operational efficiencies. The outcome industry determined Standard Operating Procedures. Then each company will refine based unique operating differences.</div>
				<div className="prose after-tile">For more information regarding our SOPs, <a href="/contact-us">contact our team</a>.</div>
			</div>
		</section>
    </div>
    <Footer />
  </div>
}

export default SOPS